import Formsy from 'formsy-react';
import _ from 'lodash';
import React from 'react';
import {Input} from '../form';
import {forgotPassword} from '../../api/'
import * as Paths from '../../constants/Paths'

class ForgotPasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showErrors: false,
      isProcessing: false,
      serverError: null
    };

  }

  onValidSubmit(model) {

    const { onSuccess = _.noop, onError = _.noop } = this.props;
    this.setState({isProcessing: true, serverError: null});

    forgotPassword(model.email, window.location.origin + Paths.RESET_PASSWORD)
      .then(() => {
        this.setState({isProcessing: false, serverError: null});
        onSuccess(model);
      })
      .catch((e) => {
        this.setState({isProcessing: false, serverError: e.message});
        onError(e.message);
      });

  }

  onInvalidSubmit() {
    this.setState({ showErrors: true });
  }

  render() {

    const { showErrors, isProcessing, serverError } = this.state;

    return (
      <Formsy onValidSubmit={(model) => this.onValidSubmit(model) }
              onInvalidSubmit={() => this.onInvalidSubmit() } >
        <Input name="email"
               type="email"
               label="Email"
               icon="envelope"
               autofocus
               showErrors={showErrors}
               inputSize="pt-large"
               validations="isEmail"
               validationError="This is not a valid email"
               required />
        {serverError && (
          <div className="pt-callout pt-intent-danger s4">
            {serverError}
          </div>
        )}
        {!isProcessing ? (
          <button type="submit" className="pt-button pt-large pt-icon-log-in pt-intent-primary">Submit</button>
        ) : (
          <button type="submit" className="pt-button pt-disabled pt-large pt-icon-log-in">Submitting...</button>
        )}
      </Formsy>
    );
  }
}

export default ForgotPasswordForm;


// WEBPACK FOOTER //
// ./src/components/forms/ForgotPasswordForm.js